import { render, staticRenderFns } from "./UploadFarm.vue?vue&type=template&id=5b02f28d&scoped=true"
import script from "./UploadFarm.vue?vue&type=script&lang=js"
export * from "./UploadFarm.vue?vue&type=script&lang=js"
import style0 from "./UploadFarm.vue?vue&type=style&index=0&id=5b02f28d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b02f28d",
  null
  
)

export default component.exports